module.exports = __webpack_public_path__ + "static/media/background-event-title-902.e98e75c7.png";